export class WatchableValue {
    #listeners = new Set();
    #onLastUnsubscribe;
    #isUpdating = false;
    #name;
    #value;
    constructor(value, removeFromStore, name) {
        this.#name = name;
        this.#onLastUnsubscribe = removeFromStore;
        this.#value = value;
    }
    set(newValue) {
        if (this.#isUpdating) {
            throw new Error(`Value "${this.#name}" was updated by a subscriber. A value may mot update as a result of an update to itself.`);
        }
        this.#isUpdating = true;
        this.#value = newValue;
        this.#listeners.forEach((subscription) => {
            subscription(this.#value);
        });
        this.#isUpdating = false;
    }
    get current() {
        return this.#value;
    }
    subscribe(listener) {
        this.#listeners.add(listener);
        return () => {
            this.#listeners.delete(listener);
            if (this.subscriptionCount === 0) {
                this.#onLastUnsubscribe();
            }
        };
    }
    get subscriptionCount() {
        return this.#listeners.size;
    }
}
//# sourceMappingURL=watchable-value.js.map